<template>
  <header class="header">
    <div class="container">
      <img src="@/assets/logo.jpg">
      <h1 @click="backToHome()">伟晟达技术开发</h1>
      <nav>
        <ul>
          <li><router-link to="/">首页</router-link></li>
          <li><router-link to="/about">关于我们</router-link></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    backToHome() {
      this.$router.push({ name: 'home' });
    }
  },
}
</script>

<style scoped>
.header {
  background-color: white;
  color: white;
  padding: 10px 0;
  text-align: center;
  margin-top: -20px;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.container h1 {
  color: purple;
  padding-left: 30px;
}

.container h1:hover {
  cursor: pointer; /* 悬停时光标形状为手指 */
}

.container img {
  width:50px;
}

nav ul {
  list-style-type: none;
  padding: 0;
}

nav ul li {
  display: inline;
  margin-left: 100px;
}

nav ul li a {
  color: #00aaff;
  text-decoration: none;
}
</style>